import { render } from "./Terms.vue?vue&type=template&id=ee4359c2&scoped=true"
const script = {}

import "./Terms.vue?vue&type=style&index=0&id=ee4359c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ee4359c2"

export default script